var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ItemCard',{attrs:{"title":_vm.checklist.title},scopedSlots:_vm._u([{key:"badges",fn:function(){return [_c('div',{staticClass:"badge state-good"},[_vm._v(_vm._s(_vm.$t("Template")))])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }